import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiMail, FiShare2, FiGlobe } = FiIcons;

const MetricsGrid = () => {
  const metrics = [
    {
      icon: FiUsers,
      number: 3321,
      label: 'Actuarial & Risk Professionals',
      subtitle: 'Engaged audience of senior actuaries, analysts, and leaders',
      color: 'from-proactuary-blue-500 to-proactuary-blue-600',
      iconColor: 'text-proactuary-blue-400'
    },
    {
      icon: FiMail,
      number: 53528,
      label: 'Sponsor Branded Email Sends',
      subtitle: '60%+ open rate',
      color: 'from-proactuary-green-500 to-proactuary-green-600',
      iconColor: 'text-proactuary-green-400'
    },
    {
      icon: FiShare2,
      number: 192000,
      suffix: '+',
      label: 'LinkedIn Impressions',
      subtitle: 'Generated during 3-week campaign period',
      color: 'from-proactuary-blue-400 to-proactuary-green-400',
      iconColor: 'text-proactuary-blue-300'
    },
    {
      icon: FiGlobe,
      number: 53,
      suffix: '+',
      label: 'Countries Reached',
      subtitle: 'Global market access',
      color: 'from-proactuary-green-400 to-proactuary-blue-400',
      iconColor: 'text-proactuary-green-400'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {metrics.map((metric, index) => (
        <motion.div
          key={index}
          className={`glass-effect rounded-2xl p-6 text-center metric-card-hover group relative overflow-hidden`}
          variants={cardVariants}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <div className={`absolute inset-0 bg-gradient-to-br ${metric.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
          
          <motion.div
            className="relative z-10"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <SafeIcon 
              icon={metric.icon} 
              className={`${metric.iconColor} text-4xl mx-auto mb-4 floating-animation`}
              style={{ animationDelay: `${index * 0.2}s` }}
            />
            
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              <CountUp
                end={metric.number}
                duration={2.5}
                delay={index * 0.2}
                separator=","
                suffix={metric.suffix || ''}
              />
            </div>
            
            <div className="text-lg font-semibold text-proactuary-blue-200 mb-1">
              {metric.label}
            </div>
            
            <div className="text-sm text-white/70">
              {metric.subtitle}
            </div>
          </motion.div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default MetricsGrid;